import React, { useEffect, useState } from 'react';
import { isEmpty } from "lodash";
import ReactDatetime from "react-datetime";
import { Button, Col, Row, Form } from "react-bootstrap";
import { capitalizeFirstLetter } from 'components/HSInduction/Shared/Helpers';
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';
import moment from 'moment';

const StepOne = ({ handleNext, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            setFormData(storedData.employeeDetails);
        }
    }, []);

    const validateForm = (formData) => {
        const errors = {
            surname: isEmpty(formData?.surname) && "Surname is required",
            title: isEmpty(formData?.title.toString()) && "Title is required",
            firstNames: isEmpty(formData?.firstNames) && "First name is required",
            // maidenName: isEmpty(formData?.maidenName) && "Maiden name is required",
            homeAddress: isEmpty(formData?.homeAddress) && "Home address is required",
            telHome: isEmpty(formData?.telHome) && "This field is required",
            telWork: isEmpty(formData?.telWork) && "Work's phone is required",
            telMobile: isEmpty(formData?.telMobile) && "Mobile is required",
            dateOfBirth: isEmpty(formData?.dateOfBirth) && "Date of birth is required",
            height: isEmpty(formData?.height.toString()) ? "Height is required" : Number(formData.height) < 1 && "Height must be greater than 0",
            weight: isEmpty(formData?.weight.toString()) ? "Weight is required" : Number(formData.weight) < 1 && "Weight must be greater than 0",
            gpName: isEmpty(formData?.gpName) && "GP's is required",
            gpAddress: isEmpty(formData?.gpAddress) && "Address is required",
            gpTel: isEmpty(formData?.gpTel) && "Telephone No is required",
        };
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);
            if (Object.values(errors).some(Boolean)) {
                setErrors(errors);
                window.scrollTo(0, 0);
                return;
            }
            setErrors([]);
            const data = {
                ...formData,
                height: Number(formData.height),
                weight: Number(formData.weight),
            }
            setAlert(CustomSweetAlert({ type: "loading" }));
            const url = `/HSInduction/SubmitEmployeeDetails?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
            const method = `post`;
            const response = await fetch(apiURL + url, {
                method,
                headers: [
                    ["Content-Type", "application/json"],
                    ["Content-Type", "text/plain"]
                ],
                body: JSON.stringify(data),
            });
            if (response.status === 200) {
                handleNext(data);
            } else {
                showErrorAlert(`Please fill out all required fields`);
            }
        } catch (error) {
            showErrorAlert("Failed to submit data");
        }
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const handleDateChange = (date) => {
        setFormData({ ...formData, dateOfBirth: date.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") });
    }

    const renderQuestion = (label, keyQ, colSize = 6, isRequired = true) => {
        return <>
            <Col sm={colSize} xs="12" className="my-1">
                <h5 className="">{label}:{isRequired === true && <span className="star">*</span>}</h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData ? formData[keyQ] : null}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                [keyQ]: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors[keyQ] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors[keyQ] && <Form.Text className="text-danger"> <span className="star">*</span> {errors[keyQ]}</Form.Text>}
                </Form.Group>
            </Col>
        </>
    }

    const hideAlert = () => setAlert(null);

    return (
        <Row>
            {alert}
            <Col sm={12} md={12}>
                <h2>1. New Employee's Details</h2>
                <span style={{ marginTop: '-15px' }}>Please fill out all required fields</span>
            </Col>
            {renderQuestion("Surname", "surname")}
            <Col sm={6} md={6} className="my-1">
                <h5>Mr/Mrs/Ms/Miss:<span className="star">*</span></h5>
                <div style={{ position: 'relative', width: '100%' }}>
                    <select
                        id="title-select"
                        name="title"
                        className={errors.title ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        value={formData ? formData["title"] : null}
                        onChange={(e) => {
                            setFormData(prevState => ({
                                ...prevState,
                                ["title"]: capitalizeFirstLetter(e.target.value),
                            }));
                        }}
                    >
                        <option value="">-Please Select-</option>
                        <option value="0">Mr</option>
                        <option value="1">Mrs</option>
                        <option value="2">Ms</option>
                        <option value="3">Miss</option>
                    </select>
                    <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                        &#9660;
                    </div>
                </div>
                {errors.title && <Form.Text className="text-danger"> <span className="star">*</span> {errors.title} </Form.Text>}
            </Col>


            {renderQuestion("First Name", "firstNames")}
            {renderQuestion("Maiden Name", "maidenName", "6", false)}
            {renderQuestion("Home Address", "homeAddress", "12")}
            {renderQuestion("Home Telephone No", "telHome")}
            {renderQuestion("Work Telephone No", "telWork")}
            {renderQuestion("Mobile Telephone No", "telMobile")}
            <Col sm={6} className="my-1">
                <h5 className="">Date of birth:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Group>
                        <ReactDatetime
                            inputProps={{
                                className: errors.dateOfBirth ? "form-control is-invalid custom-input" : "form-control custom-input",
                                name: "dateOfBirth",
                                disabled: false,
                                onKeyDown: (e) => { e.preventDefault() }
                            }} defaultValue={new Date()}
                            value={formData?.dateOfBirth ? moment(formData?.dateOfBirth) : null}
                            onChange={handleDateChange}
                            timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                        />
                    </Form.Group>
                    {errors.dateOfBirth && <Form.Text className="text-danger"> <span className="star">*</span> {errors.dateOfBirth} </Form.Text>}
                </Form.Group>
            </Col>
            {renderQuestion("Height", "height")}
            {renderQuestion("Weight", "weight")}
            {renderQuestion("GP's Name", "gpName", "12")}
            {renderQuestion("Address", "gpAddress", "12")}
            {renderQuestion("Telephone No", "gpTel")}
            <Col sm={12} className="d-flex justify-content-end mt-3">
                <Button onClick={handleSubmit} variant="success" className="btn-lg btn-shadow btn-step">Next Step</Button>
            </Col>
        </Row>


    );
};

export default StepOne;